import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseTemplate from '../BaseTemplate';
import { Button, Label } from '../../atoms';
import {
  ReportingDetailsIndicatorsAddForm,
  TranslationOrganism,
} from '../../organisms';
import cn from 'classnames';
import styles from './ReportingDetailsIndicatorsAddTemplate.module.css';
import { IndicatorResponseDto } from '../../../store/landscapeAPI/indicator/dto/response/indicator-response.dto';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

export interface ReportingDetailsIndicatorsAddTemplateProps {
  data: IndicatorResponseDto;
  handleAddIndicator: (indicator: IndicatorResponseDto) => void;
  handleOnChange: (indicator: IndicatorResponseDto) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsIndicatorsAddTemplate: FC<
  ReportingDetailsIndicatorsAddTemplateProps
> = ({
  data,

  handleAddIndicator,
  handleOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Create Indicator" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/indicators')}
          className={cn(styles.buttonLink)}
        >
          Go back to indicator overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsIndicatorsAddForm
        data={data}
        handleIndicator={handleAddIndicator}
        handleOnChange={handleOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsIndicatorsAddTemplate;
